<div class="component-wrapper" style="overflow-y: auto;">
    <ng-container *ngIf="showAnfrageInfo">
        <review-anfrage-info
            [inputAnfrage]="anfrage"
            [showBereich]="showBereich"
            [showAusschreibung]="showAusschreibung" 
            [showPhase]="showPhase"
            [showProjInfo]="showAnfrageInfo"></review-anfrage-info>
        <app-info></app-info>
    </ng-container>
</div>
<div class="collapse-wrapper">
    <button (click)="onToggleClick()" tabindex="0">
        <span *ngIf="!showAnfrageInfo" class="arrow-left" [title]="'navigation.expand' | translate"></span>
        <span *ngIf="showAnfrageInfo" class="arrow-right" [title]="'navigation.collapse' | translate"></span>
    </button>
</div>